export function nullableText(value: string): string | null {
  return value.trim() ? value : null;
}

export function nullableNumber(value: string): number | null {
  return value.trim() ? Number(value) : null;
}
